import { VendorRebateCategoryProgramDetail } from '../../../components/Vendor/RebateCategories';

export function RebateCategoryProgram() {
  return <VendorRebateCategoryProgramDetail />;
}
